module.exports = __webpack_public_path__ + "img/manage.a91a807b.jpg";